// JavaScript source code

function changeFont() {
    var x = document.getElementById("Font-0-3").value;
    document.getElementById("textOutput").style.fontFamily = x;
}

function AutoUpdate() {
    var x = document.getElementById("Name-0-0").value;
    document.getElementById("textOutput").innerHTML = x;

    if (x === "silver") {
        document.getElementById("textOutput").style.textShadow = "2px 2px silver";
    } else {
        document.getElementById("textOutput").style.textShadow = "2px 2px darkgrey";
    }
}

function changeColor(id) {
    var x = document.getElementById(id).id;
    document.getElementById("textOutput").style.color = x;

    var y = document.getElementById(id).value;

    if (y === "18k Gold-Plated") {
        document.getElementById("textOutput").className = "goldimg";
    } else if (y === "Silver-Plated") {
        document.getElementById("textOutput").className = "silverimg";
    }
}

// ── Variant ID sync ──────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {

    // Button-style variant picker
    document.querySelectorAll('input[data-variant-input][type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
            syncVariantId();
        });
    });

    // Dropdown-style variant picker
    document.querySelectorAll('select[data-variant-input]').forEach(function (select) {
        select.addEventListener('change', function () {
            syncVariantId();
        });
    });

    function syncVariantId() {
        var form = document.querySelector('form[id*="AddToCartForm"]');
        if (!form) return;

        var selectedOptions = [];

        var wrappers = document.querySelectorAll('.variant-input-wrap[data-index]');
        wrappers.forEach(function (wrap) {
            var parent = wrap.closest('[data-type]');
            if (!parent) return;

            if (parent.dataset.type === 'button') {
                var checked = wrap.querySelector('input[type="radio"]:checked');
                if (checked) selectedOptions.push(checked.value);
            } else if (parent.dataset.type === 'dropdown') {
                var sel = wrap.querySelector('select[data-variant-input]');
                if (sel) selectedOptions.push(sel.value);
            }
        });

        var variants = window.productVariants;
        if (!variants) return;

        var matched = variants.find(function (v) {
            return v.options.every(function (opt, i) {
                return opt === selectedOptions[i];
            });
        });

        if (matched) {
            var idInput = form.querySelector('input[name="id"]');
            if (idInput) idInput.value = matched.id;
        }
    }
});
